import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  responsaveis: [],
  parametrosPadraoExercicio: []
});

function responsavelReducer(state = initialState, action) {
  switch (action.type) {
    case types.RESPONSAVEIS_LIST_START:
    case types.PARAMS_START: {
      return startLoad(state);
    }

    case types.RESPONSAVEIS_LIST_SUCCESS: {
      return endLoad(state.set('responsaveis', fromJS(action.payload)));
    }

    case types.PARAMS_SUCCESS: {
      return endLoad(
        state.set('parametrosPadraoExercicio', fromJS(action.payload))
      );
    }

    case types.RESPONSAVEIS_LIST_ERROR:
    case types.PARAMS_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default responsavelReducer;
